module.exports = {
  QUESTION: 'questionsList:question'
};
